<template>
    <div class="date-time-picker-wrapper">
      <vue-ctk-date-time-picker
        ref="timePicker"
        v-model="dateValue"
        @input="handleDateFilterChange"
        :id="id"
        :range="range"
        :only-date="true"
        :no-header="true"
        :no-shortcuts="true"
        :no-button="true"
        :no-button-now="true"
        :auto-close="true"
        :color="'var(--secondary-color)'"
        :disable-time="true"
        :format="dateFormat"
        :formatted="dateFormat"
        :label="datePickerLabel"
        :minDate="minDate"
        :maxDate="getMaxDate">
      </vue-ctk-date-time-picker>
    </div>
</template>
<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment"

export default {
    name: "date-picker",
    components: { VueCtkDateTimePicker },
    props: ["value","setMinDate","label","maxDate","range","resetValue"],
    watch: { 
        resetValue: function(value) {
            if(value) {
                this.$refs.timePicker.value = null;
                
            }
        }
    },
    data() {
        return {
            dateValue: null,
            datePickerLabel:'Select start date'
        };
    },
    computed: {
        dateFormat() {
            return "YYYY-MM-DD";
        },
        minDate() {
            return this.setMinDate ? moment(new Date()).format(this.dateFormat) : ''
        },
        id() {
            return this._uid
        },
        getMaxDate() {
            return this.maxDate ? this.maxDate : ''
        }
    },
    created() {
        if(this.value) {
            this.dateValue = this.value
        }
        if(this.label){
            this.datePickerLabel = this.label
        }
        this.range = this.range;
    },
    methods: {
        handleDateFilterChange() {
            this.$emit('input', this.dateValue)
        }
  }
}
</script>
<style scoped>
.date-time-picker-wrapper >>> .datepicker[style] {
  min-width: 260px !important;
  max-width: 280px !important;
  font-family: artifaktElementRegular !important;
}

.date-time-picker-wrapper >>> ::placeholder {
  color: #BFBFBFDE;
  font-size: 15px;
}

.date-time-picker-wrapper >>> .datetimepicker.visible {
  z-index: 1;
}

.date-time-picker-wrapper >>> .date-time-picker {
  font-family: artifaktElementRegular !important;
}

.date-time-picker-wrapper >>> .date-time-picker input {
  font-family: artifaktElementRegular !important;
}

.date-time-picker-wrapper >>> .date-time-picker label {
  font-family: artifaktElementRegular !important;
}

.date-time-picker-wrapper >>> .date-time-picker span {
  font-family: artifaktElementRegular !important;
}

.date-time-picker-wrapper >>> .date-time-picker p {
  font-family: artifaktElementRegular !important;
}

p {
  margin-bottom: 0;
}
.upper-date {
  font-size: 14px;
}
.lower-date {
  font-size: 12px;
  color: gray;
}

.date-time-picker {
  margin-left: 0 !important;
  .field-input {
    border-radius: 10px! important;
    border: 1px solid rgba(136, 136, 136, 1);
  }
}
</style>


// WEBPACK FOOTER //
// src/components/homebase/DatePicker.vue